import { Component, ChangeDetectionStrategy,
  Output, EventEmitter } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { AuthService } from '../shared/auth.service';

@Component({
  selector: 'igo-auth-intern',
  template: require('./auth-intern.component.html'),
  styles: [require('./auth-intern.component.styl')],
  changeDetection: ChangeDetectionStrategy.Default
})
export class AuthInternComponent {
  public error: string = '';
  public form: FormGroup;

  @Output() onLogin: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    public auth: AuthService,
    fb: FormBuilder
  ) {
    this.form = fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  login(values: any) {
    this.auth.login(values.username, values.password)
      .subscribe(
        () => {
          this.onLogin.emit(true);
        },
        (error: any) => {
          this.error = error.error.message;
        }
      );
    return false;
  }

  loginAnonymous() {
    this.auth.loginAnonymous().subscribe(() => {
      this.onLogin.emit(true);
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/auth/auth-form/auth-intern.component.ts